export default "__VITE_ASSET__DEkzlAi$__"